<template>
  <v-dialog v-model="localDialogVisible" max-width="500px" @click:outside="closeDialog">
    <v-card class="rounded-xl">
      <v-card-title class="d-flex justify-space-between align-center px-6 pt-6 pb-2">
        <span style="color: #315fd8; font-family: 'Roboto Condensed', sans-serif; font-size: 1.35rem; font-weight: 700; letter-spacing: -0.01em;">Teste 7 dias grátis</span>
        <v-btn icon @click="closeDialog" variant="text" size="small">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="px-6">
        <v-window v-model="step">
          <!-- ETAPA 1 -->
          <v-window-item :value="1">
            <p style="color: #647089; font-family: 'Inter', sans-serif; font-size: 14.5px; line-height: 1.5;" class="mb-6">
              Preencha seus dados abaixo para iniciar seu período de testes na plataforma Veri Salvatori.
            </p>

            <v-form ref="formStep1" v-model="validStep1" lazy-validation>
              <v-text-field
                v-model="fullName"
                :readonly="loading"
                :rules="[rules.required]"
                class="mb-2"
                clearable
                label="Nome e Sobrenome"
                prepend-inner-icon="mdi-account-outline"
                style="font-family: 'Inter', sans-serif;"
              ></v-text-field>

              <v-text-field
                v-model="email"
                :readonly="loading"
                :rules="[rules.required, rules.email]"
                class="mb-2"
                clearable
                label="E-mail"
                prepend-inner-icon="mdi-email-outline"
                style="font-family: 'Inter', sans-serif;"
              ></v-text-field>

              <v-text-field
                v-model="phone"
                :readonly="loading"
                :rules="[rules.required, rules.phone]"
                class="mb-2"
                clearable
                label="Telefone (WhatsApp)"
                prepend-inner-icon="mdi-phone-outline"
                type="tel"
                style="font-family: 'Inter', sans-serif;"
                @input="formatPhone"
                maxlength="13"
              ></v-text-field>

              <v-select
                v-model="course"
                :items="['TECM', 'TEMFC']"
                :rules="[rules.required]"
                :class="course ? 'mb-1' : 'mb-4'"
                label="Título de interesse"
                prepend-inner-icon="mdi-book-education-outline"
                style="font-family: 'Inter', sans-serif;"
              ></v-select>

              <div v-if="course" style="font-family: 'Inter', sans-serif; font-size: 12px; color: #666;" class="mb-4 pl-1">
                <span v-if="course === 'TEMFC'">Título de Especialista em Medicina de Família e Comunidade (TEMFC)</span>
                <span v-else-if="course === 'TECM'">Título de Especialista em Clínica Médica (TECM)</span>
              </div>

              <v-btn
                :disabled="!validStep1"
                block
                color="#315fd8"
                style="height: 52px; font-size: 15px; color: white; border-radius: 12px; text-transform: none; font-weight: 600;"
                @click="nextStep"
                variant="elevated"
                rounded
              >
                Continuar
              </v-btn>
            </v-form>
          </v-window-item>

          <!-- ETAPA 2 -->
          <v-window-item :value="2">
            <div class="mb-6 pa-4 rounded-lg" style="background-color: #f5f8fa; border: 1px solid #e1e8ed;">
              <div class="d-flex align-center mb-1">
                <v-icon color="#315fd8" size="20" class="mr-2">mdi-email-outline</v-icon>
                <span style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 600; color: #333;">{{ email }}</span>
              </div>
              <div class="d-flex align-center">
                <v-icon color="#315fd8" size="20" class="mr-2">mdi-book-education-outline</v-icon>
                <span style="font-family: 'Inter', sans-serif; font-size: 14px; color: #666;">Título de interesse: <strong style="color: #333">{{ course }}</strong></span>
              </div>
            </div>

            <p style="color: #666; font-family: 'Inter', sans-serif; font-size: 14px;" class="mb-4">
              Agora, crie uma senha segura para acessar sua conta e liberar seu teste grátis.
            </p>

            <v-alert v-if="errorMessage" type="error" class="mb-4" style="font-family: 'Inter', sans-serif; font-size: 14px;">
              {{ errorMessage }}
            </v-alert>

            <v-form ref="formStep2" v-model="validStep2" @submit.prevent="onSubmit" lazy-validation>
              <v-text-field
                v-model="password"
                :readonly="loading"
                :rules="[rules.required, rules.passwordMin]"
                class="mb-2"
                clearable
                label="Senha"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                style="font-family: 'Inter', sans-serif;"
              ></v-text-field>

              <v-text-field
                v-model="confirmPassword"
                :readonly="loading"
                :rules="[rules.required, confirmPasswordRule]"
                class="mb-4"
                clearable
                label="Confirmar Senha"
                prepend-inner-icon="mdi-lock-check-outline"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showConfirmPassword ? 'text' : 'password'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                style="font-family: 'Inter', sans-serif;"
              ></v-text-field>

              <v-checkbox
                v-model="lgpdConsent"
                :rules="[rules.requiredConsent]"
                class="mb-6"
                color="#315fd8"
                hide-details="auto"
              >
                <template v-slot:label>
                  <div style="font-family: 'Inter', sans-serif; font-size: 13px;">
                    Concordo com a 
                    <a href="https://verisalvatori.com.br" target="_blank" @click.stop style="color: #315fd8; text-decoration: underline;">Política de Privacidade</a>
                    (LGPD).
                  </div>
                </template>
              </v-checkbox>

              <div class="d-flex">
                <v-btn
                  variant="text"
                  color="#666"
                  style="height: 52px; font-size: 15px; border-radius: 12px; text-transform: none; font-family: 'Inter', sans-serif;"
                  @click="step = 1"
                  class="mr-2"
                  :disabled="loading"
                >
                  <v-icon left>mdi-arrow-left</v-icon> Voltar
                </v-btn>
                <v-btn
                  :disabled="!validStep2"
                  :loading="loading"
                  color="#10b981"
                  class="flex-grow-1"
                  style="height: 52px; font-size: 15px; color: white; border-radius: 12px; text-transform: none; font-weight: 600;"
                  type="submit"
                  variant="elevated"
                >
                  Criar Conta e Testar!
                </v-btn>
              </div>
            </v-form>
          </v-window-item>

          <!-- ETAPA 3 -->
          <v-window-item :value="3">
            <div class="text-center py-6">
              <v-icon color="#10b981" size="64" class="mb-4">mdi-email-fast-outline</v-icon>
              <h3 style="font-family: 'Roboto Condensed', sans-serif; color: #0d172e; font-weight: 700; font-size: 1.35rem;" class="mb-2">Quase lá! Falta só um detalhe.</h3>
              
              <div style="font-family: 'Inter', sans-serif; color: #555; font-size: 14.5px;" class="mb-6">
                <p class="mb-4">
                  Sua conta foi criada com sucesso. Para garantirmos a sua segurança e liberar seu ambiente de estudos, <strong>enviamos um link de confirmação para o seu e-mail.</strong>
                </p>
                <div style="background-color: #f5f8fa; border: 1px solid #e1e8ed; color: #666; font-size: 13.5px;" class="pa-3 rounded-lg d-flex align-center text-left">
                  <v-icon color="#f59e0b" size="24" class="mr-3">mdi-alert-circle-outline</v-icon>
                  <span><strong>Não encontrou nossa mensagem?</strong> Dê uma olhadinha rápida na sua caixa de <strong>spam</strong> ou lixo eletrônico.</span>
                </div>
              </div>

              <v-btn
                block
                color="#315fd8"
                style="height: 52px; font-size: 15px; color: white; border-radius: 12px; text-transform: none; font-weight: 600;"
                @click="closeDialog"
                variant="elevated"
                rounded
              >
                Entendi, ir para o Login
              </v-btn>
            </div>
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    step: 1,
    validStep1: false,
    validStep2: false,

    fullName: "",
    email: "",
    phone: "",
    course: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    lgpdConsent: false,
    loading: false,
    errorMessage: "",

    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      passwordMin: v => (v && v.length >= 6) || 'Sua senha deve ter no mínimo 6 caracteres.',
      requiredConsent: value => !!value || 'Você deve aceitar a Política de Privacidade.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail Inválido.'
      },
      phone: value => {
        const pattern = /^\d{2} \d{4,5}-\d{4}$/;
        return pattern.test(value) || 'Telefone inválido (ex: 11 91234-1234).';
      }
    },
  }),
  computed: {
    confirmPasswordRule() {
      return (v) => v === this.password || 'As senhas não coincidem.';
    },
    localDialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        if (!val) this.closeDialog();
      }
    }
  },
  mounted() {
    if (this.dialogVisible) {
      this.checkQueryParams();
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.checkQueryParams();
      }
    }
  },
  methods: {
    checkQueryParams() {
      const q = this.$route.query;
      if (q.nome) this.fullName = q.nome;
      if (q.email) this.email = q.email;
      if (q.telefone) {
        this.phone = q.telefone;
        this.formatPhone(); // Format the phone number immediately
      }
      if (q.titulo) {
        const t = q.titulo.toUpperCase();
        if (t.includes('TECM') || t.includes('CLINICA') || t.includes('CLÍNICA')) {
          this.course = 'TECM';
        } else if (t.includes('TEMFC') || t.includes('FAMILIA') || t.includes('FAMÍLIA')) {
          this.course = 'TEMFC';
        }
      }
    },
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.resetForm();
      }, 300);
    },
    nextStep() {
      if (this.$refs.formStep1.validate()) {
        this.errorMessage = "";
        this.step = 2;
      }
    },
    formatPhone(val) {
      let currentVal = typeof val === 'string' ? val : this.phone;
      if (!currentVal) return;
      
      currentVal = String(currentVal);
      let digits = currentVal.replace(/\D/g, '');
      if (digits.length > 11) digits = digits.substring(0, 11);
      
      let formatted = digits;
      if (digits.length > 2 && digits.length <= 6) {
        formatted = digits.replace(/^(\d{2})(\d+)/, '$1 $2');
      } else if (digits.length > 6 && digits.length <= 10) {
        formatted = digits.replace(/^(\d{2})(\d{4})(\d+)/, '$1 $2-$3');
      } else if (digits.length === 11) {
        formatted = digits.replace(/^(\d{2})(\d{5})(\d{4})/, '$1 $2-$3');
      }
      
      this.phone = formatted;
    },
    async onSubmit() {
      if (!this.$refs.formStep2.validate()) return;

      this.loading = true;
      this.errorMessage = "";
      const payload = {
        fullName: this.fullName,
        email: this.email,
        phone: this.phone,
        course: this.course,
        password: this.password,
        date: new Date().toISOString()
      };
      
      try {
        await this.$store.dispatch('registerTrialUser', payload);
        this.step = 3;
      } catch (error) {
        console.error("Erro ao salvar dados:", error);
        if (error.code === 'auth/email-already-in-use') {
          this.errorMessage = "Este e-mail já está cadastrado. Por favor, faça login.";
        } else {
          this.errorMessage = "Ocorreu um erro ao criar a conta. Tente novamente.";
        }
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.fullName = "";
      this.email = "";
      this.phone = "";
      this.course = "";
      this.password = "";
      this.confirmPassword = "";
      this.showPassword = false;
      this.showConfirmPassword = false;
      this.lgpdConsent = false;
      this.errorMessage = "";
      this.step = 1;
      if (this.$refs.formStep1) this.$refs.formStep1.resetValidation();
      if (this.$refs.formStep2) this.$refs.formStep2.resetValidation();
    }
  },
};
</script>

<style scoped>
</style>
